<div class="site-wrapper">
    <app-header></app-header>
    <div class="main">
        <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="showFooter"></app-footer>
</div>
